import { Copy, Image } from "lucide-react";
import React from "react";
import { RoutingDestination } from "@/types/fitconnect.ts";

const DetailRow = ({ name, children }) => (
  <div className="py-2 grid grid-cols-[8em_1fr] gap-5">
    <dt className="text-sm font-medium text-gray-700">{name}</dt>
    <dd className="flex text-sm text-gray-700 overflow-hidden">{children}</dd>
  </div>
);

interface DestinationSearchResultProps {
  result: RoutingDestination;
}

export const DestinationSearchResult: React.FC<
  DestinationSearchResultProps
> = ({ result }) => {
  return (
    <div className="card shadow-sm bg-white">
      <div className="card-body">
        <div className="card-title">
          {result.destinationLogo ? (
            <div className="flex shrink-0 items-center justify-center w-16 h-16 rounded-md mr-3">
              <img
                src={result.destinationLogo}
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
          ) : (
            <div className="flex shrink-0 items-center justify-center w-16 h-16 rounded-md bg-base-300 mr-3">
              <Image className="text-gray-500" width={32} />
            </div>
          )}
          <h2 className="text-2xl text-black">{result.destinationName}</h2>
        </div>

        <dl className="ml-22">
          <DetailRow name="Destination-ID">
            <div className="text-nowrap overflow-hidden text-ellipsis">
              {result.destinationId}
            </div>
            <button
              className="btn btn-xs btn-ghost ml-2"
              onClick={() =>
                navigator.clipboard.writeText(result.destinationId)
              }
            >
              <Copy size={16} />
            </button>
          </DetailRow>

          <DetailRow name="Signatur">
            <div className="text-nowrap overflow-hidden text-ellipsis">
              {result.destinationSignature}
            </div>
            <button
              className="btn btn-xs btn-ghost ml-2"
              onClick={() =>
                navigator.clipboard.writeText(result.destinationSignature)
              }
            >
              <Copy size={16} />
            </button>
          </DetailRow>

          {result.address && (
            <DetailRow name="Adresse">
              <address className="text-sm text-gray-700">
                <div>
                  {result.address.street} {result.address.houseNumber}
                </div>
                <div>
                  {result.address.zip} {result.address.city}
                </div>
                {result.address.additional && (
                  <div>{result.address.additional}</div>
                )}
              </address>
            </DetailRow>
          )}

          {result.customParameters &&
            Object.keys(result.customParameters).length > 0 && (
              <DetailRow name="Parameter">
                <div className="overflow-x-auto w-full">
                  <table className="table table-xs table-zebra w-full border border-base-200">
                    <thead className="text-xs">
                      <tr>
                        <th>Key</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(result.customParameters).map(
                        ([key, value]) => (
                          <tr key={key}>
                            <td className="font-mono text-xs">{key}</td>
                            <td>{value}</td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </DetailRow>
            )}

          <DetailRow name="Quelle">{result.origin}</DetailRow>
        </dl>
      </div>
    </div>
  );
};
